import {computed} from "mobx";
import {DetailsTabModel} from "../details-tab.model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitionLinkModel} from "../../../../../containers/competition-container/models/competition.link-model";
import {PAGES} from "../../../../../core/consts";

export class CompetitionIndexPageTabModel extends DetailsTabModel {
  @computed get linkModel(): CompetitionLinkModel {
    const linkModel: CompetitionLinkModel = new CompetitionLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === null || this.currentLinkModel.name === PAGES.GAME_CENTER.index;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_scores';
  }
}
